import { CursorPayload, SocketSubscriber } from "@features/builder/types"
import useHTMLElementSize from "@hooks/useHTMLElementSize"
import { useReactFlow, useStore } from "@xyflow/react"
import { useRef } from "react"
import { stringToColor } from "utils/string"

const CURSOR_WIDTH = 24
const CURSOR_HEIGHT = 24

type SubscriberCursorProps = {
  subscriber: SocketSubscriber
  cursor: CursorPayload
}

const SubscriberCursor = (props: SubscriberCursorProps) => {
  const textRef = useRef<SVGTextElement | null>(null)
  const textBBox = textRef.current?.getBBox()
  const flow = useReactFlow()
  const { x, y } = flow.flowToScreenPosition({ x: props.cursor.x, y: props.cursor.y })
  const editorDiv = useStore((s) => s.domNode)

  // rerender in case of editor changing width or height to make sure there is no cursor left outside of editor
  useHTMLElementSize(editorDiv)

  if (!editorDiv) return

  const editorBounds = editorDiv.getBoundingClientRect()
  const outOfBoundsHorizontally = x < editorBounds.left || x > editorBounds.right
  const outOfBoundsVertically = y < editorBounds.top || y > editorBounds.bottom

  // do not render cursor that does not fit into editor area
  if (outOfBoundsHorizontally || outOfBoundsVertically) {
    return
  }

  return (
    <svg
      width={CURSOR_WIDTH}
      height={CURSOR_HEIGHT}
      style={{
        position: "absolute",
        overflow: "visible",
        top: y,
        left: x,
      }}
    >
      {/* cursor element */}
      <path
        fill={stringToColor(props.subscriber.name)}
        stroke="#000"
        strokeWidth="2"
        d="M5.5 3.21V20.8c0 .45.54.67.85.35l4.86-4.86a.5.5 0 0 1 .35-.15h6.87a.5.5 0 0 0 .35-.85L6.35 2.85a.5.5 0 0 0-.85.35Z"
      />

      {/* text background */}
      <rect
        x={(textBBox?.x ?? 0) - 5}
        y="24"
        width={(textBBox?.width ?? 0) + 10}
        height="16"
        fill="#000000A3"
        rx="5"
        ry="5"
      />

      <text
        ref={textRef}
        x={CURSOR_WIDTH / 2}
        y={CURSOR_HEIGHT + 8}
        textAnchor="middle"
        alignmentBaseline="middle"
        fill="#FFFFFF"
        fontSize={11}
        style={{ userSelect: "none" }}
      >
        {props.subscriber.name}
      </text>
    </svg>
  )
}

export default SubscriberCursor
